import script from "./ProgramCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgramCard.vue?vue&type=script&setup=true&lang=js"

import "./ProgramCard.vue?vue&type=style&index=0&id=04802ca8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04802ca8"]])

export default __exports__